import { axiosIntance } from "./config";

export const getAllWork = async () => {
  const response = await axiosIntance.get("/works");
  return response.data;
};

export const getAllEmployeeWork = async () => {
  const response = await axiosIntance.get("/work-employees");
  return response.data;
};

export const createWork = async (data) => {
  const response = await axiosIntance.post("/works", data);
  return response.data;
};

export const updateWork = async (id, payload) => {
  const response = await axiosIntance.put(`/works/${id}`, payload);
  return response.data;
};

export const deleteWork = async (id) => {
  const response = await axiosIntance.delete(`/works/${id}`);
  return response.data;
};

export const getWorkFranchise = async (franchiseId,teamId) => {
  const response = await axiosIntance.get(`/works/franchises/${franchiseId}/${teamId}`);
  return response.data;
};

export const createWorkData = async (workId,data) => {
  const response = await axiosIntance.post(`/works/${workId}/data`,data);
  return response.data;
};
